import OccupiedRoomModal from './OccupiedRoomModal.vue';

export default OccupiedRoomModal;
